module.exports = __webpack_public_path__ + "media/images/hackerrank/datascientist-9e36e6e9645835345ec0953ee6a2d0d6.png";